import { Stack, StackProps, styled } from '@mui/material';

import { generateClasses } from '../../../../../../../utils/helper';

export const barGraphClasses = generateClasses('BarGraph', ['bar']);

export const Root = styled((props: StackProps) => <Stack justifyContent="center" gap={2} {...props} />)(
  ({ theme }) => ({
    [`& .${barGraphClasses.bar}`]: {
      flex: 1,
    },
  })
);
